(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cardSelector = '[data-maison-card]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const enhanceCard = (card) => {
      if (card.dataset.maisonCardEnhanced === 'true') return;

      const track = card.querySelector('[data-maison-card-track]');
      const mediaLink = card.querySelector('[data-maison-card-link]');
      const slides = Array.from(card.querySelectorAll('[data-maison-card-slide]'));
      const dots = Array.from(card.querySelectorAll('[data-maison-card-dot]'));
      const previous = card.querySelector('[data-maison-card-previous]');
      const next = card.querySelector('[data-maison-card-next]');

      card.dataset.maisonCardEnhanced = 'true';
      if (!track || slides.length < 2) return;

      card.dataset.maisonCardReady = 'true';
      let activeIndex = 0;
      let pointerStartScroll = 0;
      let scrollFrame = 0;

      const update = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
      };

      const goTo = (index) => {
        const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({
          left: slides[targetIndex].offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
        update(targetIndex);
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const width = track.clientWidth || 1;
          update(Math.round(track.scrollLeft / width));
        });
      }, { passive: true });

      mediaLink?.addEventListener('pointerdown', () => {
        pointerStartScroll = track.scrollLeft;
      }, { passive: true });

      mediaLink?.addEventListener('click', (event) => {
        if (Math.abs(track.scrollLeft - pointerStartScroll) > 8) event.preventDefault();
      });

      update(0);
    };

    const enhance = (root = document) => {
      root.querySelectorAll(cardSelector).forEach(enhanceCard);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
    } else {
      enhance();
    }

    document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-home-editorial"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('maison-video-gallery')) {

  class MaisonVideoGallery extends HTMLElement {

    constructor() {
      super();

      this.handlePlay = this.handlePlay.bind(this);
    }


    connectedCallback() {

      this.addEventListener(
        'play',
        this.handlePlay,
        true
      );

    }


    disconnectedCallback() {

      this.removeEventListener(
        'play',
        this.handlePlay,
        true
      );

    }


    handlePlay(event) {

      if (!event.target.matches('video')) return;


      this.querySelectorAll('video').forEach((video) => {

        if (
          video !== event.target &&
          !video.paused
        ) {

          video.pause();

        }

      });

    }

  }


  customElements.define(
    'maison-video-gallery',
    MaisonVideoGallery
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-home-luxury"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-motion-gallery')) {
  customElements.define('maison-motion-gallery', class extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.md-home__motion-toggle'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('.md-home__motion-card');
          const video = card && card.querySelector('video');
          if (!video) return;

          const willPlay = video.paused;
          this.querySelectorAll('video').forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
          this.buttons.forEach((otherButton) => {
            if (otherButton !== button) {
              otherButton.setAttribute('aria-pressed', 'false');
              const otherLabel = otherButton.querySelector('.md-home__motion-toggle-label');
              if (otherLabel) otherLabel.textContent = 'Play';
            }
          });

          if (willPlay) {
            video.play().catch(() => {});
            button.setAttribute('aria-pressed', 'true');
            const label = button.querySelector('.md-home__motion-toggle-label');
            if (label) label.textContent = 'Pause';
          } else {
            video.pause();
            button.setAttribute('aria-pressed', 'false');
            const label = button.querySelector('.md-home__motion-toggle-label');
            if (label) label.textContent = 'Play';
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
